import { useState, useEffect } from 'react';

export const usePermissions = () => {
  const [scopes, setScopes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      try {
        const data = JSON.parse(localStorage.getItem('data') || '{}');
        const newScopes = data.scopes || [];

        if (newScopes.length > 0 && scopes.length === 0) {
          setScopes(newScopes);
          setLoading(false);
          clearInterval(interval); // Stop polling once we have scopes
        } else if (newScopes.length === 0 && !loading) {
          // Optional: handle logout case
        }
      } catch {
        setScopes([]);
      }
    }, 200); // Check every 200ms – fast enough, low overhead

    // Initial check
    const initialData = JSON.parse(localStorage.getItem('data') || '{}');
    if (initialData.scopes?.length > 0) {
      setScopes(initialData.scopes);
      setLoading(false);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, []);

  const hasPermission = (requiredScopes) => {
    if (!Array.isArray(requiredScopes)) {
      requiredScopes = [requiredScopes];
    }
    return requiredScopes.some(scope => scopes.includes(scope));
  };

  const canCreate = (entity) => hasPermission(`${entity}:create`);
    const canEdit = (entity) => hasPermission(`${entity}:edit`) || hasPermission(`${entity}:update`);
    const canDelete = (entity) => hasPermission(`${entity}:delete`);
    const canApprove = (entity) => hasPermission(`${entity}:approve`);
    const canReject = (entity) => hasPermission(`${entity}:reject`);
    const canView = (entity) => hasPermission(`${entity}:view`);

  return {
    loading,
    hasPermission,
    canCreate,
    canEdit,
    canDelete,
    canApprove,
    canReject,
    canView,
    scopes
  };
};